(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-dp-routines-root]';
  var FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), textarea, input, select, ' +
    '[tabindex]:not([tabindex="-1"])';

  function visibleFocusable(modal) {
    var nodes = modal.querySelectorAll(FOCUSABLE_SELECTOR);
    var result = [];
    var index;

    for (index = 0; index < nodes.length; index += 1) {
      if (
        !nodes[index].hasAttribute('hidden') &&
        nodes[index].offsetParent !== null
      ) {
        result.push(nodes[index]);
      }
    }

    return result;
  }

  function initRoot(root) {
    if (!root) return;

    if (typeof root._dpRoutinePopupCleanup === 'function') {
      root._dpRoutinePopupCleanup();
    }

    var activeModal = null;
    var activeTrigger = null;
    var bodyState = null;
    var cleanup = [];

    function on(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options || false);
      cleanup.push(function () {
        target.removeEventListener(eventName, handler, options || false);
      });
    }

    function lockBody() {
      var scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      bodyState = {
        overflow: document.body.style.overflow,
        paddingRight: document.body.style.paddingRight
      };

      document.body.style.overflow = 'hidden';

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + 'px';
      }
    }

    function unlockBody() {
      if (!bodyState) return;

      document.body.style.overflow = bodyState.overflow;
      document.body.style.paddingRight = bodyState.paddingRight;
      bodyState = null;
    }

    function openModal(modal, trigger) {
      if (!modal) return;

      if (activeModal && activeModal !== modal) {
        closeModal(activeModal, false);
      }

      activeModal = modal;
      activeTrigger = trigger;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockBody();

      window.requestAnimationFrame(function () {
        var focusable = visibleFocusable(modal);
        var preferred = modal.querySelector('[data-dp-close-modal]');
        var panel = modal.querySelector('.dp-routine-modal__panel');
        var target = preferred || focusable[0] || panel;

        if (!target) return;

        try {
          target.focus({ preventScroll: true });
        } catch (error) {
          target.focus();
        }
      });
    }

    function closeModal(modal, restoreFocus) {
      if (!modal) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      unlockBody();

      if (
        restoreFocus !== false &&
        activeTrigger &&
        document.contains(activeTrigger)
      ) {
        try {
          activeTrigger.focus({ preventScroll: true });
        } catch (error) {
          activeTrigger.focus();
        }
      }

      activeModal = null;
      activeTrigger = null;
    }

    function closeAll() {
      if (activeModal) closeModal(activeModal, false);
    }

    function handleRootClick(event) {
      var opener = event.target.closest
        ? event.target.closest('[data-dp-open-modal]')
        : null;

      if (opener && root.contains(opener)) {
        var modalId = opener.getAttribute('data-dp-open-modal');
        var modal = document.getElementById(modalId);

        event.preventDefault();
        openModal(modal, opener);
        return;
      }

      var closeControl = event.target.closest
        ? event.target.closest('[data-dp-close-modal]')
        : null;

      if (
        closeControl &&
        activeModal &&
        activeModal.contains(closeControl)
      ) {
        event.preventDefault();
        closeModal(activeModal, true);
      }
    }

    function handleKeydown(event) {
      if (!activeModal) return;

      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        closeModal(activeModal, true);
        return;
      }

      if (!(event.key === 'Tab' || event.keyCode === 9)) return;

      var focusable = visibleFocusable(activeModal);

      if (!focusable.length) {
        event.preventDefault();

        var panel = activeModal.querySelector(
          '.dp-routine-modal__panel'
        );

        if (panel) panel.focus();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    }

    on(root, 'click', handleRootClick);
    on(document, 'keydown', handleKeydown);
    on(root, 'dp-routine:close-modals', closeAll);

    root._dpRoutinePopupCleanup = function () {
      var index;

      closeAll();

      for (index = 0; index < cleanup.length; index += 1) {
        cleanup[index]();
      }

      root._dpRoutinePopupCleanup = null;
    };
  }

  function init(scope) {
    var roots = [];
    var found;
    var index;

    scope = scope || document;

    if (
      scope.nodeType === 1 &&
      scope.matches &&
      scope.matches(ROOT_SELECTOR)
    ) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      found = scope.querySelectorAll(ROOT_SELECTOR);

      for (index = 0; index < found.length; index += 1) {
        roots.push(found[index]);
      }
    }

    for (index = 0; index < roots.length; index += 1) {
      initRoot(roots[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector(ROOT_SELECTOR)
      : null;

    if (
      event.target.matches &&
      event.target.matches(ROOT_SELECTOR)
    ) {
      root = event.target;
    }

    if (
      root &&
      typeof root._dpRoutinePopupCleanup === 'function'
    ) {
      root._dpRoutinePopupCleanup();
    }
  });
})();
